import { Reveal, SectionHeading } from "./Primitives";
import { WHY_CARDS } from "@/data/content";
import { Sparkles, Home, MessageCircle, Wallet, Calendar, Heart } from "lucide-react";

const ICONS = {
  sparkles: Sparkles, home: Home, "message-circle": MessageCircle,
  wallet: Wallet, calendar: Calendar, heart: Heart,
};

export const WhyPerfectTouch = () => (
  <section id="why" className="bg-[#050505] py-16 md:py-20">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal>
        <SectionHeading
          overline="Why Perfect Touch"
          title={<>Your satisfaction is <span className="gold-gradient italic">our priority</span></>}
          subtitle="Six principles that define every service we deliver."
        />
      </Reveal>

      <div className="mt-10 grid gap-px bg-white/5 sm:grid-cols-2 lg:grid-cols-3 border border-white/5">
        {WHY_CARDS.map((c, i) => {
          const Icon = ICONS[c.icon];
          return (
            <Reveal key={c.n} delay={(i % 3) * 0.06} y={20}>
              <article
                data-testid={`why-card-${i}`}
                className="group relative h-full bg-[#050505] p-5 md:p-6 hover:bg-[#101010] transition-colors duration-500"
              >
                <div className="flex items-center gap-3">
                  <span className="font-display text-2xl text-white/15 group-hover:text-gold/40 transition-colors duration-500">
                    {c.n}
                  </span>
                  <Icon size={20} className="text-gold" strokeWidth={1.5} />
                  <h3 className="font-display text-lg text-white">{c.title}</h3>
                </div>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{c.text}</p>
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold group-hover:w-full transition-all duration-500" />
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
